import React, { useState } from 'react';
import _ from 'lodash';

import AdminSearchBar from 'shared-components/AdminSearchBar/AdminSearchBar';
import { categoryNamesFromIds } from '../../utils';
import searchStyles from './CategorySearchBar.module.css';
import '../styles/Checklist.css';

const CategoryChecklist = ({
  handleRowValueChange,
  selectedCategoryIds,
  categories,
}) => {
  const [activeChecklist, setActiveChecklist] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const categoryHasMatch = (category, searchRegex) =>
    categories.find(
      (c) =>
        (c.id === category.id || c.parentCategoryId === category.id) &&
        searchRegex.test(c.name)
    );

  const renderCategories = (
    parent,
    selectedCategoryIds,
    searchRegex,
    toggleCategoryId
  ) => {
    return (
      <ul className={parent == null ? 'list' : ''}>
        {categories
          .filter(
            (c) =>
              c.parentCategoryId === parent && categoryHasMatch(c, searchRegex)
          )
          .map((c) => {
            return (
              <li key={c.id}>
                <label className="checkbox" htmlFor={c.id}>
                  {c.name}
                  <input
                    type="checkbox"
                    id={c.id}
                    name={c.name}
                    value={c.id}
                    checked={selectedCategoryIds.includes(c.id)}
                    onChange={() => toggleCategoryId(c.id, c.parentCategoryId)}
                  />
                  <span className="checkmark">
                    <i className="fa fa-check" aria-hidden="true" />
                  </span>
                </label>
                <div className="subcategory">
                  {renderCategories(
                    c.id,
                    selectedCategoryIds,
                    searchRegex,
                    toggleCategoryId
                  )}
                </div>
              </li>
            );
          })}
      </ul>
    );
  };

  const toggleActiveChecklist = () => setActiveChecklist(!activeChecklist);

  const toggleCategoryId = (categoryId, parentCategoryId) => {
    let categoryIds = selectedCategoryIds;

    // remove self and any subcategories
    if (categoryIds.includes(categoryId)) {
      const children = categories
        .filter((c) => c.parentCategoryId === categoryId)
        .map((c) => c.id);
      categoryIds = _.difference(categoryIds, children.concat(categoryId));
    } else {
      // add category and parent if present
      categoryIds = categoryIds.concat(categoryId);
      if (parentCategoryId) {
        categoryIds = categoryIds.concat(parentCategoryId);
      }
    }
    handleRowValueChange('categoryIds', categoryIds);
  };

  return (
    <div
      className={`checklist-container ${
        activeChecklist ? 'active' : 'inactive'
      }`}
      onMouseLeave={() => setActiveChecklist(false)}
    >
      <div className="selected">
        <button type="button" onClick={toggleActiveChecklist}>
          <div className="label">
            {categoryNamesFromIds(selectedCategoryIds, categories)}
          </div>
        </button>
      </div>
      {activeChecklist && (
        <div className="dropdown">
          <AdminSearchBar
            query={searchQuery}
            setQuery={setSearchQuery}
            stayOpen
            placeholder="Search"
            styles={searchStyles}
          />
          {renderCategories(
            null,
            selectedCategoryIds,
            new RegExp(
              searchQuery.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'),
              'i'
            ),
            toggleCategoryId
          )}
        </div>
      )}
    </div>
  );
};

export default CategoryChecklist;
